/**
 * bootprompt.js locale configuration
 * locale : Croatian
 * author : Mario Bašić
 */

import { addLocale } from "../bootprompt";

addLocale("hr", {
  OK      : "OK",
  CANCEL  : "Odustani",
  CONFIRM : "Potvrdi",
});
